/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindCityQueryResponse
 */
export interface FindCityQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof FindCityQueryResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FindCityQueryResponse
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof FindCityQueryResponse
     */
    country: string;
}

/**
 * Check if a given object implements the FindCityQueryResponse interface.
 */
export function instanceOfFindCityQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "country" in value;

    return isInstance;
}

export function FindCityQueryResponseFromJSON(json: any): FindCityQueryResponse {
    return FindCityQueryResponseFromJSONTyped(json, false);
}

export function FindCityQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCityQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'state': json['state'],
        'country': json['country'],
    };
}

export function FindCityQueryResponseToJSON(value?: FindCityQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'state': value.state,
        'country': value.country,
    };
}

